import React, { useEffect, useState } from 'react';
import PanelBase from '../../components/PanelBase/PanelBase';
import LoadSpin from '../../components/LoadSpin/LoadSpin';
import { API } from '../../API/API';
import moment from 'moment';
import HistoryIcon from '../../svg/HistoryIcon';

const DiwoAIHistory = (props) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const getData = async () => {
        let tData = [];

        try {
            setLoading(true);

            await API.get("/api/odata/ai/history").then(response => {
                if (response?.status == 200 && response?.data?.rettype == 0) {
                    if (response?.data?.retdata?.length > 0) {
                        tData = response?.data?.retdata;
                    }
                }
            });

        } finally {
            setLoading(false);
        }

        setData(tData);
    }

    useEffect(() => {
        getData();
    }, []);

    const onDismiss = () => {
        props.onDismiss();
    }

    const onHistory = (pId) => {
        if (pId && props?.onHistory) {
            onDismiss();
            props.onHistory(pId);
        }
    }

    return (
        <PanelBase
            isOpen={props.isOpen}
            headerText="Түүх"
            onDismiss={onDismiss}
            PanelType="small"
        >
            {loading ? <LoadSpin space /> : (
                <div style={{ marginTop: 12 }}>
                    {data?.map((r, index) => {
                        return (
                            <div onClick={() => onHistory(r?.aichatid)} key={index} style={{ marginTop: 12, display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <div style={{ height: 20, width: 20 }}>
                                    <HistoryIcon />
                                </div>
                                <div style={{ marginLeft: 4, color: '#0358A7', fontSize: 14 }}>
                                    {moment(r?.updated).format("YYYY.MM.DD HH:mm:ss")}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </PanelBase>
    );
}

export default DiwoAIHistory;